import { medicalAssistantsUpsertModalRouteStore } from '../domain/upsert-modal-store';

export default (showing = true) => {
  medicalAssistantsUpsertModalRouteStore.setValue('showingDeleteConfirmationModal', showing);
};
